export default __webpack_public_path__ + "static/media/current-location.39192af6.svg";